// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"7b94e725","392":"b9d10dee","508":"7b94e725","548":"7b94e725","944":"086ddb7c"}[chunkId] + ".chunk.css";
};